module.exports = __webpack_public_path__ + "img/fig_2.3ec5b506.svg";